/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import _map from 'lodash/map'

export const blind_box_collect_list = createAsyncThunk(
  '/live/gift/blind_box_collect_list',
  async (blindBoxId: number, store: any) => {
    const resp = await http.post('/live/gift/blind_box_collect_list', {
      ...store.getState().env.deviceinfo,
      blind_box_id: blindBoxId,
    })
    return resp.data.data
  }
)

/** /live/gift/blind_box_collect_time */
export const blind_box_collect_time = createAsyncThunk(
  '/live/gift/blind_box_collect_time',
  async (_p: any, store: any) => {
    const resp = await http.post('/live/gift/blind_box_collect_time', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

/** 开启收集 /live/gift/blind_box_collect_open */
export const blind_box_collect_open = createAsyncThunk(
  '/live/gift/blind_box_collect_open',
  async (blindBoxId: number, store: any) => {
    const resp = await http.post('/live/gift/blind_box_collect_open', {
      ...store.getState().env.deviceinfo,
      blind_box_id: blindBoxId,
    })
    return resp.data.data
  }
)

/** 领取奖励 */
export const blind_box_collect_reward = createAsyncThunk(
  '/live/gift/blind_box_collect_reward',
  async (blindBoxId: number, store: any) => {
    const resp = await http.post('/live/gift/blind_box_collect_reward', {
      ...store.getState().env.deviceinfo,
      blind_box_id: blindBoxId,
    })
    return resp.data.data
  }
)

export type IGiftItem = {
  cost: number
  cost_display: number
  id: number
  name: string
  url: string
  is_collect: boolean
  /** 是否高级礼物 */
  senior: boolean
  /** 是否高级礼物 */
  is_advanced: boolean
  /** 是否最大价值礼物 */
  is_best_gift: boolean
}
export interface IBlindBoxItem {
  name: string
  url: string
  cost: number
  cost_display: number
  id: string
}
export type IBlindBoxInfo = {
  /** 名称	 */
  name: string
  /** 图片	 */
  url: string
  /** 价值	  */
  cost: number
  cost_display: number
  /** 是否开启收集	 */
  is_open_collect: boolean
  /** 礼物总数	  */
  total_gift_num: number
  /** 已经搜集的数量  */
  collect_gift_num: number

  id: number
}
export type IRwardGift = {
  name: string
  url: string
  cost: number
  cost_display: number
}
const initialState: {
  list: IBlindBoxItem[]
  collect: {
    blind_box_info: IBlindBoxInfo
    gift_list: IGiftItem[]
    probability_list: string[]
    reward_gift_info: IRwardGift
  }
  isCollect: boolean
  currentBlindBoxId: number
} = {
  list: [],
  collect: {
    blind_box_info: {} as IBlindBoxInfo,
    gift_list: [],
    probability_list: [],
    reward_gift_info: {} as IRwardGift,
  },
  isCollect: false,
  currentBlindBoxId: 0,
}

export const BlindBoxDetailSlice = createSlice({
  name: 'BlindBoxDetail',
  initialState,
  reducers: {
    setCurrentBlindBoxId(state, action) {
      state.currentBlindBoxId = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(blind_box_collect_list.fulfilled, (state, action) => {
      Object.assign(state, {collect: {...action.payload}})
    })

    builder.addCase(blind_box_collect_time.fulfilled, (state, action) => {
      Object.assign(state, {list: [...action.payload?.blind_box_list]})
    })

    builder.addCase(blind_box_collect_open.fulfilled, (state, action) => {
      Object.assign(state, {isCollect: true})
    })

    builder.addCase(blind_box_collect_reward.fulfilled, (state, action) => {
      // Object.assign(state, {collect: {...action.payload}})
    })
  },
})

export const useBlindBoxDetail = () =>
  useSelector((store) => store.BlindBoxDetail)

export default BlindBoxDetailSlice.reducer
export const BlindBoxDetailActions = BlindBoxDetailSlice.actions
